export default __webpack_public_path__ + "static/home-f6690170617007e2cdae9aef4920f46d.png";